import _ from "lodash";
import roles from "dictionaries/UserRoles";
import { clearSession } from "libs/sessionStorage";

export function isVendor(role) {
  return role === roles.vendor;
}

export function isStaff(role) {
  return role === roles.staff;
}

export function isLab(role) {
  return role === roles.lab;
}

export function isAccountant(role) {
  return role === roles.accountant;
}

export const defineUserRole = role => {
  switch (role) {
    case "ADMIN":
    case "Staff":
      return roles.staff;
    case "VENDOR":
    case "Full Member":
      return roles.vendor;
    case "LAB":
    case "Test Lab":
      return roles.lab;
    case "ACCOUNTING":
      return roles.accountant;
    default:
      return null;
  }
};

export function getFullName(user) {
  return _.has(user, "firstname") && _.has(user, "lastname")
    ? `${user.firstname} ${user.lastname}`
    : "n/a";
}

export const isCTIAUser = user => {
  return user.company === "CTIA";
};

export const getUrlRequestPrefix = user => {
  return user.isStaff ? "/admin" : "";
};

export const getUserPrefix = user => {
  if (!user) return "/";
  if (user.isStaff) return "admin";
  if (user.isAccountant) return "accountant";
  return "/";
};

export function sayGoodbye() {
  clearSession();
  window.location = "/";
  return null;
}

export const getRequestOwner = (request, user) => {
  if (user.isVendor) return user.companyid;
  if (user.isStaff) return request.submitter.companyid;
  return null;
};



// WEBPACK FOOTER //
// ./src/helpers/Users.js